// extracted by mini-css-extract-plugin
module.exports = {"headerWrap":"Header_headerWrap__1pq_M","welcomeText":"Header_welcomeText__3oXjf","filterPanel":"Header_filterPanel__kMK1J"};